import styled from 'styled-components';
import Button from '@Utils/shared/components/Button-v3';

export const Wrapper = styled.div`
  min-width: 150px;
`;

export const ButtonLogo = styled(Button)`
  font-weight: 600;
  min-width: 150px;
  height: 40px;
  border-radius: 6px;
  padding: 0 15px;
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.3);

  &:disabled {
    background-color: #593a2d;
    color: rgba(255, 255, 255, 0.5) !important;
  }
`;
